export var CustomFormElementType;
(function (CustomFormElementType) {
    CustomFormElementType["INPUT"] = "input";
    CustomFormElementType["TEXTAREA"] = "textarea";
    CustomFormElementType["SELECT"] = "select";
    CustomFormElementType["MUTLISELECT"] = "multiselect";
    CustomFormElementType["CHECKBOX"] = "checkbox";
    CustomFormElementType["PAIN_SCALE_SELECT"] = "painScaleSelect";
    CustomFormElementType["PAIN_INTENSITY"] = "painIntensity";
    CustomFormElementType["PAIN_LOCATION_3D"] = "painLocation3D";
    CustomFormElementType["PAIN_LOCATION_3D_IMAGE"] = "painLocation3DImage";
    CustomFormElementType["PAIN_SELECT"] = "painSelect";
    CustomFormElementType["ACCOMPANYING_SYMPTOMS"] = "accompanyingSymptoms";
    CustomFormElementType["PAIN_OCCURRENCES"] = "painOccurrences";
    CustomFormElementType["PAIN_SCALE"] = "painScale";
})(CustomFormElementType || (CustomFormElementType = {}));
//# sourceMappingURL=custom-form-element-type.enum.js.map